import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Layout } from './components/website';
import { Homepage, HowToFund, FastBusinessCash, InvoiceFinance, UnsecuredLoans, FinanceOptions, InsuranceClaims, PrivateClients, FundingApplication, Contact } from './pages/website';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import UserDashboardModern from './pages/UserDashboardModern';
import AdminDashboardModern from './pages/AdminDashboardModern';
import ProtectedRoute from './components/ProtectedRoute';
import { initializeAuth } from './store/slices/authSlice';
import { AppDispatch } from './store';
import Profile from './pages/Profile';
import Notifications from './pages/Notifications';
import Deposit from './pages/Deposit';
import Withdraw from './pages/Withdraw';
import Transfer from './pages/Transfer';
import TransferError from './pages/TransferError';
import WithdrawError from './pages/WithdrawError';
import CreditCards from './pages/CreditCards';

function App() {
  const dispatch = useDispatch<AppDispatch>();

  // Initialize auth state on app load
  useEffect(() => {
    dispatch(initializeAuth());
  }, [dispatch]);

  return (
    <Router>
      <Routes>
        {/* Auth routes without Layout */}
        <Route path="/login" element={<Login />} />
        <Route path="/admin/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        
        {/* Dashboard routes without Layout */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <UserDashboardModern />
          </ProtectedRoute>
        } />
        <Route path="/dashboard/profile" element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        } />
        <Route path="/dashboard/notifications" element={
          <ProtectedRoute>
            <Notifications />
          </ProtectedRoute>
        } />
        <Route path="/dashboard/deposit" element={
          <ProtectedRoute>
            <Deposit />
          </ProtectedRoute>
        } />
        <Route path="/dashboard/withdraw" element={
          <ProtectedRoute>
            <Withdraw />
          </ProtectedRoute>
        } />
        <Route path="/dashboard/transfer" element={
          <ProtectedRoute>
            <Transfer />
          </ProtectedRoute>
        } />
        <Route path="/transfer-error" element={
          <ProtectedRoute>
            <TransferError />
          </ProtectedRoute>
        } />
        <Route path="/withdraw-error" element={
          <ProtectedRoute>
            <WithdrawError />
          </ProtectedRoute>
        } />
        <Route path="/dashboard/credit-cards" element={
          <ProtectedRoute>
            <CreditCards />
          </ProtectedRoute>
        } />
        <Route path="/admin/dashboard" element={
          <ProtectedRoute requiredRole="admin">
            <AdminDashboardModern />
          </ProtectedRoute>
        } />
        
        {/* Website routes with Layout */}
        <Route path="/" element={
          <Layout>
            <Homepage />
          </Layout>
        } />
        <Route path="/knowledge/how-to-fund" element={
          <Layout>
            <HowToFund />
          </Layout>
        } />
        <Route path="/finance/fast-business-cash" element={
          <Layout>
            <FastBusinessCash />
          </Layout>
        } />
        <Route path="/finance/invoice-finance" element={
          <Layout>
            <InvoiceFinance />
          </Layout>
        } />
        <Route path="/finance/unsecured-loans" element={
          <Layout>
            <UnsecuredLoans />
          </Layout>
        } />
        <Route path="/finance" element={
          <Layout>
            <FinanceOptions />
          </Layout>
        } />
        <Route path="/insurance/companies" element={
          <Layout>
            <InsuranceClaims />
          </Layout>
        } />
        <Route path="/insurance/private-clients" element={
          <Layout>
            <PrivateClients />
          </Layout>
        } />
        <Route path="/contact" element={
          <Layout>
            <Contact />
          </Layout>
        } />
        <Route path="/apply-for-funding" element={
          <ProtectedRoute>
            <Layout>
              <FundingApplication />
            </Layout>
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;
